<template>
  <div class="table-container" >
    <div v-show="!isNotEmpty" class="no-data"> <center > No data to display! </center> </div>
    <div v-show="isNotEmpty" class="table-not-empty">
      <div class="new-container-fluid">
        <div class="table-column" v-for="(heading, key) in titleMap">
          <!-- Table Header -->
          <div class="table-heading-container">
            <div class="new-table-heading">
              {{ heading }}
              <img src="src/assets/column-sort.svg" alt="">
            </div>
          </div>
          <div class="table-data"
               v-for="(column_value, index) in pageColumn(key)">
             <!-- Dates -->
             <router-link :to="renderEndpointForColumn(pageColumn('id'), index)"
                          v-if="key.includes('date')">
               {{ column_key | formatDateTime('DD MMMM, YYYY') }}
             </router-link>
             <!-- Document Links --> 
             <a v-bind:href="parse(column_value, 'link')"
                v-else-if="key.includes('document')">
               {{ parse(column_value, 'name') }} 
             </a>
             <!-- Data source tags --> 
             <div class="tag-pill" 
                 :title="item"
                 v-on:click="copyToClipboard"
                 v-else-if="Array.isArray(column_value)"
                 v-for="(item, index) in column_value"
                 :key="index">
              {{ item }}
            </div>
            <!-- True/False values --> 
            <router-link :to="renderEndpointForColumn(pageColumn('id'), index)"
                         v-else-if="[false, true].includes(column_value)">
              <span v-if="column_value">Yes</span>
              <span v-else>No</span> 
            </router-link>
            <!-- Normal text values --> 
            <router-link :to="renderEndpointForColumn(pageColumn('id'), index)"
                         v-else>
              {{ column_value }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="list-header">
          <div class="row new-width">
            <div :class="key.includes('date') ? 'col-sm-2 table-heading': 'col-sm-2 table-heading'"
                 v-for="(heading, key) in titleMap"
                 @click="orderBy(key)">
              {{ heading }}
              <img src="src/assets/column-sort.svg" alt="">
            </div>
          </div>
        </div>
        <div class="list-wrapper">
          <div class="list-body" v-for="(row, index) in page" :key="index">
              <span v-show="filterdRow(row)">
                <p class="grouping-caption" v-if="showNewGrouping(row)">{{ row[groupBy] }}</p>
                  <div class="row list-container" :class="{'list-container-selected': isSelected(row)}">

                    <div :class="key.includes('date') ? 'col col-sm-2 col-xs-12': 'col col-sm-2 col-xs-12' " v-for="(column, key) in titleMap" :key="key">
                      <span class="card-heading">{{ titleMap[key] }}</span>
                      <router-link :to="renderEndpoint(row)" :class="getClass(row, key)" v-if="key.includes('date')">{{ row[key] | formatDateTime('DD MMMM, YYYY')}}</router-link>
                        <a v-bind:href="parse(row[key], 'link')"
                           :class="getClass(row, key)" target="_blank" v-if="key.includes('document')">{{ parse(row[key], 'name') }}</a>
                      <div class="tag-pill" :title="item"
                           v-on:click="copyToClipboard"
                           v-else-if="Array.isArray(row[key])" v-for="(item, index) in row[key]" :key="index">
                        {{ item }}
                      </div>

                      <router-link :to="renderEndpoint(row)" :class="getClass(row,key)" v-else-if="[false, true].includes(row[key])">
                        <span v-if="row[key]">Yes</span>
                        <span v-else>No</span>
                      </router-link>
                      <router-link :to="renderEndpoint(row)" :class="getClass(row, key)" v-else>{{ row[key] }}</router-link>
                  </div>
                </div>
              </span>
          </div>
        </div>
      </div>
      <div class="paginator" >
        <div class="row paginator-width">
          <button class="col-sm-1 col-fit page-buttons previous" :disabled="disablePrevious" @click="previous()">previous</button>
          <button class="col-sm-1 col-fit page-buttons">{{ currentPage }} of {{ numberOfPages }} <img src="src/assets/counter-arrow.svg" alt=""> </button>
          <button class="col-sm-1  col-fit page-buttons next" @click="next()" :disabled="disableNext">next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import $ from 'jquery';
import _ from 'lodash';
import store from '../store.js';
import constants from '../constants.js';
import { bus } from '../main.js';
var currentGrouping = '';
var trackKey = '';
var beforeEnd = 0;

export default {
  created(){
    this.to = this.pageSize;
  },
  beforeDestroy: function(){
    console.log($('input:checkbox'));
    store.state.filteredList = [];
    console.log(this.tableName)
    if (this.tableName === constants.WIZARD_INDICATORS) {
      $('input:checkbox').each(function (index, value) {
        console.log('VALUE: ', value);
        $(value).prop('checked')
      });
    }
  },
  props: {
    tableName: { default: '' },
    tableBody: { default: () => ({})},
    pageSize: {default: 5},
    titleMap: { default: () => ({}) },
    endPoint: { default: '' },
    colClass: {default: "col-sm-2 col-xs-12"}
  },
  data () {
    return {
      page: [],
      currentPage: 1,
      pageTracker: 1,
      from: 0,
      to: 0,
      selectedRows: [],
      filtering: 0
    };
  },
  computed: {
    ...mapState({
      groupBy: state => state.groupBy,
      group: state => state.group,
      sortingOrder: state => state.sortingOrder
    }),
    isNotEmpty: function(){
      let _isNotEmpty = true;
      if(Object.keys(this.tableBody).length == 0){
        _isNotEmpty = false;
      }
      return _isNotEmpty;
    },
    filteredList: function(){
      return store.state.filteredList;
    },
    getFilteredObjects: function(){
      var filtered = this.tableBody.filter(function(row){
        return this.indexOf(row.id) >= 0;
      },this.filteredList);
      return filtered;
    },
    pages: function(){
      var source;
      if (this.filteredList.length != 0){
        source = this.getFilteredObjects;
      }else{
        source = this.tableBody;
      }
      if(source.length < this.from){
        this.from = 0;
        this.to = this.pageSize;
        this.currentPage = 1;
      }
      if(this.groupBy !== null){
        this.page = _.slice(source.sort(this.compare(this.groupBy)), this.from, this.to);
      }else{
        this.page = _.slice(source, this.from, this.to);
      }
      return source;
    },
    numberOfPages: function(){
      return  Math.ceil(this.pages.length/this.pageSize);
    },
    disableNext: function(){
      if (this.to >= this.pages.length)return true;
    },
    disablePrevious: function(){
      if(this.from == 0)return true;
    },
  },
  methods:{
    pageColumn: function(columnName){
      let result = this.page.reduce(function(column, row){ 
        column.push(row[columnName])
        return column 
      }, []);
      return result;
    },
    selectAll: function(){
      let checkbox = $('#table-header-checkbox');
      console.log('selectAll', $(checkbox).prop('checked'));
      if($(checkbox).prop('checked') === true){
        $('input:checkbox').prop('checked', true);
      }else{
        $('input:checkbox').prop('checked', false);
      }
    },
    next: function(){
      this.currentPage++;
      var lastPage = this.pages.length;
      if(this.to >= lastPage || (this.to + this.pageSize) >= lastPage ){
        this.from = this.to;
        beforeEnd = this.to;
        this.to = lastPage;
      }else{
        this.from = this.to;
        this.to = this.to + this.pageSize;
      }
    },
    previous: function(){
      this.currentPage--;
      if (this.to == this.pages.length){
        this.to = beforeEnd;
        this.from = this.from - this.pageSize;
      }else{
        this.from = this.from - this.pageSize;
        this.to = this.to - this.pageSize;
      }
    },
    filterdRow: function(row){
      var found = false;
      if(this.filteredList.length == 0){
        return true;
      }else{
        for (var i = 0; i < this.filteredList.length; i++) {
          if(this.filteredList[i] == row.id){
            found = true;
          }
        }
        return found;
      }
    },
    // orders the table and sorts the rows into their specific groupings
    showNewGrouping: function(row){
      var showNewGrouping = false;
      if(this.groupBy !== null && trackKey == this.groupBy){
        var key = this.groupBy;
        if (currentGrouping == row[key]){
          showNewGrouping = false;
        }
        else if (currentGrouping != row[key]){
          currentGrouping = row[key];
          showNewGrouping =  true;
        }
        return showNewGrouping;
      }
    },
    // compare function used to sort tables by column
    compare: function(key){
      if(key !== null) trackKey = key;
      return function(a, b){
        if (a[key] < b[key])return -1;
        if (a[key] > b[key])return 1;
        return 0;
      };
    },
    // orders columns in ascending order on click
    orderBy: function(column){
      this.page.sort(this.compare(column));
    },
    parse: function(url, str){
      try{
        var urlSplit = url.split("/");
        var l = urlSplit.length;
        if (str == 'name') {
          // a = urlSplit[l-1].split('_').join('/');
          return urlSplit[l-1];
        }
        else{ return url; }
      }
      catch (e) {
        if (str == 'name') {
          return "No file available";
        }
      }
    },
    renderEndpoint: function (row){
      var endpoint = this.endPoint;
      var newEndpoint;
      var replaceWith; 
      var key; 
      if(endpoint == ''){
        return ''
      }
      newEndpoint = endpoint.replace(/\{\{(.*?)\}\}/gi, function(x){
        replaceWith = x.replace('{{', '');
        replaceWith = replaceWith.replace('}}', '');
        key = replaceWith.trim();
        return x = row[key];
      });
      return newEndpoint;
    }, 
    renderEndpointForColumn: function(row, index){
      var endpoint = this.endPoint;
      var newEndpoint;
      if (endpoint == ''){
        return '';
      }
      newEndpoint = endpoint.replace(/\{\{(.*?)\}\}/gi, function(x){
        return x = row[index];
      });
      return newEndpoint;
    },
    isSelected: function(row) {
      return this.selectedRows.indexOf(row.id) != -1;
    },
    getClass: function(row, key) {
      return key == 'status' ? `status ${row[key]}` : '';
    },
    copyToClipboard: function(event){
      let doc = window.document;
      let notificationObject = { data: {
          type: 'info',
          content: "Tag Name has been copied to your clipboard",
          title: "Tag Copied"
        }
      };

      if (window.getSelection && doc.createRange){
        let selection = window.getSelection();
        let range = doc.createRange();
        range.selectNodeContents(event.target);
        selection.removeAllRanges();
        selection.addRange(range);
        if (document.execCommand('copy')){
          bus.$emit('notification', notificationObject);
        }
        selection.removeAllRanges();
      } else if (doc.body.createTextRange) {
        let range = doc.body.createTextRange();
        range.moveToElementText(event.target);
        range.select();
        if (document.execCommand('copy')){
          bus.$emit('notificattion', notificationObject)
        }
      }

    }
  }
};
</script>

<style lang="scss" scoped>
@import "../css/constants";
button:focus {
  outline:0;
}
.col-fit{
  flex: 0 0 0;
  padding-left: 1rem;
  padding-right: 0;
  width: auto;
}
button:disabled,
button[disabled]{
  background-color:transparent;
  color: #969494;
}

.row{
  margin-left: 0px;
}

.no-data{
  height: 100%;
  margin: 22% 0;
  text-transform:uppercase;
  font-size: 33px;
  font-weight: bolder;
  color:rgba(51, 122, 183, 0.22);
}

.page-buttons{
  font-family: 'Roboto', sans-serif;
  font-weight: thin;
  font-size: 12px;
  box-shadow: 1px solid #e4e4e4;
  color:#5F5E5E;
}

.previous, .next {
  width: 70px;
}

.paginator{
  width: 100vh;
  padding-left: $p16;
  padding-right: $p16;
  margin: $p24 auto 0 auto;
  width: 100%;
  z-index: 999;

  .paginator-width {
    text-align: center;
    width: 350px;
    margin: 0 auto;
  }
}

.paginator button{
  padding: 4px 8px;
  border-radius: 2px;
  padding-top: 6px;
  margin-right: $p8;
  text-transform: capitalize;
  outline: none;
}
.paginator button:nth-child(2) {
  text-transform: lowercase;
  padding-right: 6px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(130,53,51,0.7);
}
.grouping-caption{
  color:grey;
  font-size: 15px;
  padding-bottom:10px;
  padding-top: 10px;
}

a{
  color: #5F5E5E;
}
a:focus, a:hover {
  color: #014c8c;
  text-decoration: none;
}

.list-wrapper {
  height: calc(100% - 10px);
  margin: 0;
  padding: 0 25px 30px 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar { width: 8px; }
  &::-webkit-scrollbar-track-piece { background-color: transparent; }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: transparent;
    border-radius: 30px;
  }

  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
    background: linear-gradient(to right, #35B8FB, #56CCF2);
    outline: 1px solid slategrey;

    border-radius: 30px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);

    &:hover { background: #35B8FB; }
  }
}

.list-body{
  font-size: $p14;
  margin-bottom: $p4;

  .odd {
    background-color: #000;
  }
}
.list-body:last-child {
  margin-bottom: 0;
}
.list-container{
  background-color: white;
  padding-top: $p16;
  padding-bottom: $p16;
  border-radius: 2px;
  box-shadow: 0px 0 2px 0 #ECECEC;
  overflow: hidden;
  margin-left: 0px;

  .col{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.list-container:nth-child(n+2) > div > * {
  vertical-align: -2px;
  line-height: 0;
}
.list-header{
  font-family: 'Roboto Slab', serif;
  padding-bottom:10px;
}
.container-fluid:last-child{
  border-bottom: 1px solid #eceeef;
}
// @media (min-width: 576px){
//   .new-width .col-sm-1 {
//       max-width: 1.333333%!important;
//   }
//   .paginator-width .col-sm-1{
//     max-width: 6.333333%!important;
//     padding-right: 0px;
//   }
//   .col-sm-2 {
//       max-width: 19%;
//   }
// }

.container-fluid{
  font-family: 'Roboto', sans-serif;
  border: 0!important;
  padding: 20px 15px;
  vertical-align: middle;
  display: none;
}

//Table Headings
.table-heading, .card-heading{
  cursor: pointer;
  color: #424242;
  font-size: 1.045rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}

.table-container{
  height: calc(100% - 103px);
}

//Checkboxes
#table-header-checkbox-label {
  margin-top: -2px;
}

.hidden-box {
  position: absolute;
  top: -9999px;
  left: -9999px;
  display: none;
  appearance: none;
  opacity: 0;
}
.check--label-box {
  display: flex;
  align-self: center;
  position: relative;
  height: 1.2rem;
  width: 1.2rem;
  background: #ffffff;
  border: 1px solid $gray4;
  border-radius: 3px;
  cursor: pointer;
}
// checked
.hidden-box:checked + .check--label {
  background-color: none;
  border-radius: 3px;
  .check--label-box {
    background-color: $blue;
    border: 1px solid $blue;
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0px;
      left: 5px;
      width: 7px;
      height: 13px;
      border: 2px solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
}
//highlight list item
.list-container-selected {
  background: #f0fbff;
  box-shadow: inset 0 0 0 1px #d9f4ff, 0 0 2px 0 rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  transition: all 0.2s ease;
}

.status {/* Rectangle: */
  border-radius: 2px;
  text-transform: capitalize;
  padding-left: 4px;
  padding-right: 4px;
  font-size: $p12;
  padding-top: 2px;
  &.active {
    color: $gray6;
    background: rgba(127,127,127,0.15);
  }
}
.col-sm-2:first {
  font-weight: 900;
  font-size: 1.125em;
}

.no-data{ min-height: 40%; }
.table-not-empty{
  height: 100%;

  .container-fluid{
    width: auto;
    height: calc(100% - 100px);
  }

  .list-header{
    width:100%;
    height: 35px;
  }

  // .table-body-container{
  //   width: auto;
  //   height: calc(100% - 30px);
  //   overflow-y: auto;
  // }

  .paginator{
    height: 50px;
    padding-top: 10px;
  }
}

.tag-pill{
  color: white;
  background: #037ba7;
  text-align: center;
  padding: 4px;
  border-radius: 2px;
  display: inline-block;
  margin-right: 6px;
  margin-top: 5px;
}
.card-heading{
  font-family: 'Roboto Slab', serif;
  display: none;
  font-size: 1.125em;
  padding-right: 10px;
}

@media only screen and (max-width: 1700px) { 
  /* For 1368*768 screens */
  .table-data > a {
    font-size: 0.8rem !important;
  }
  .table-data {
    border-right: 35px solid transparent !important;
    min-width: 12rem !important;
    max-width: 12rem !important;
  } 
}

@media only screen and (max-width: 1200px) {
  /* For mobile phones: */
  .list-header { display: none;}
  .card-heading{
    display: inline-block;
  }
  .list-container .col{
    width: 100%;
  }
  .table-data {
    min-width: 11.5rem !important;
    max-width: 11.5rem !important;
  }  
}


@media only screen and (min-width: 468px) and (max-width: 1200px) {
  /* For mobile phones: */
  .no-data{
    height: 100%;
    margin: 22% 0;
    font-size: 1.4em;
    color:rgba(51, 122, 183, 0.22);
  }
  .container-fluid{
    display: block;
  }
  .new-container-fluid{
    display: none !important;
  } 
}

@media only screen and (max-width: 468px) {
  /* For mobile phones: */
  .no-data{
    height: 100%;
    margin: 22% 0;
    font-size: 1.3em;
    color:rgba(51, 122, 183, 0.22);
  }
  .container-fluid{
    display: block;
  }
  .new-container-fluid{
    display: none !important;
  }
}

// Table redesign change
.table-column > * {
  min-height: 18%;
  max-height: 18%;
}

.table-data {
  display: flex;
  border-right: 65px solid transparent;
  border-bottom: 1px solid #f9f9f9;
  min-width: 18rem;
  max-width: 18rem;
  align-items: center;
  overflow: hidden;
  margin: 0.3rem 0 0.3rem 0;
}

.table-data > a {
  line-height: 1.2;
  align-items: center;
  display: flex; 
  font-size: 0.9rem; 
}

.new-table-heading { 
  cursor: pointer;
  font-weight: bold;
  min-height: 1.5em;
  position:fixed;
}

.new-container-fluid {
  display:flex;
  flex-direction: row;
  height: 85%;
  overflow-y: auto;
}

.table-heading-container {
  min-height:1.5em;
}   
</style>




// WEBPACK FOOTER //
// src/components/GenericTable.vue